@if (timeoutRequest()) {
  <app-timeout></app-timeout>
} @else if (requestStarted()) {
  <div class="flex h-full justify-content-center align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  @if (form) {
    <div [formGroup]="form" class="modalForm">
      <div class="flex flex-column gap-2 mb-3">
        <label for="label" class="font-semibold w-full"
          >{{ "gate_administration.location_form.label" | translate }}*</label
        >
        <input pInputText id="label" formControlName="label" autocomplete="off" />
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="email" class="font-semibold w-full">{{
          "gate_administration.location_form.email" | translate
        }}</label>
        <input pInputText id="email" formControlName="email" autocomplete="off" />
      </div>
      <div style="grid-column: 1 / 3" class="flex flex-column gap-2 mb-3">
        <span class="font-semibold">{{ "gate_administration.location_form.position" | translate }}*</span>
        <div class="modalWindowMap" id="locationMapContainer"></div>
      </div>
      <div
        class="flex flex-column gap-2 mb-3"
        *appHasPermission="{
          permissions: [permissions.allPermissions.MEDIA_CREATE, permissions.allPermissions.MEDIA_UPDATE],
        }"
      >
        <label for="floorMap" class="font-semibold w-full">{{
          "gate_administration.location_form.floor_map" | translate
        }}</label>
        <div id="floorMap" class="flex align-items-center justify-content-between">
          @if (location.floorMapUrl) {
            <a [href]="location.floorMapUrl" target="_blank">{{
              "gate_administration.location_form.open_floor_map" | translate
            }}</a>
          } @else if (!selectedFloorMap) {
            <span>{{ "gate_administration.location_form.no_floor_map" | translate }}</span>
          }
          <p-fileUpload
            #fileUpload
            [showUploadButton]="false"
            [showCancelButton]="false"
            styleClass="customFileUpload"
            class="w-full"
            (click)="onFileUploadClick(fileUpload)"
            (onSelect)="onFileSelect($event)"
            [chooseLabel]="translate.instant('common.choose_file')"
            name="file"
            accept="image/*,application/pdf"
            maxFileSize="10000000"
          >
            <ng-template #content let-uploadedFiles>
              @if (uploadedFiles.length > 0) {
                {{ uploadedFiles.length }}
                {{ "common.files_selected" | translate }}
              }
            </ng-template>
          </p-fileUpload>
        </div>
      </div>
      <div class="flex flex-column gap-2 mb-3">
        <label for="phone" class="font-semibold w-full">{{
          "gate_administration.location_form.phone" | translate
        }}</label>
        <input pInputText id="phone" formControlName="phone" autocomplete="off" />
      </div>
      <ng-container formGroupName="address">
        <div class="flex flex-column gap-2 mb-3">
          <label for="street" class="font-semibold w-full">{{ "common.address.street" | translate }}*</label>
          <input pInputText id="street" formControlName="street" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3">
          <label for="number" class="font-semibold w-full">{{ "common.address.number" | translate }}*</label>
          <input pInputText id="number" formControlName="number" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3">
          <label for="zipCode" class="font-semibold w-full">{{ "common.address.zipCode" | translate }}*</label>
          <input pInputText id="zipCode" formControlName="zipCode" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3">
          <label for="city" class="font-semibold w-full">{{ "common.address.city" | translate }}*</label>
          <input pInputText id="city" formControlName="city" autocomplete="off" />
        </div>
        <div class="flex flex-column gap-2 mb-3">
          <label for="country" class="font-semibold w-full">{{ "common.address.country" | translate }}*</label>
          <p-select id="country" formControlName="country" [options]="countries" class="w-full">
            <ng-template let-country #selectedItem>
              {{ country.label | translate }}
            </ng-template>
            <ng-template let-country #item>
              {{ country.label | translate }}
            </ng-template>
          </p-select>
          <!-- <input
          pInputText
          id="country"
          formControlName="country"
          autocomplete="off"
        /> -->
        </div>
      </ng-container>
      <div style="grid-column: 1 / 3" class="flex flex-column gap-2 mb-3">
        <label for="notes" class="font-semibold w-full">{{
          "gate_administration.location_form.notes" | translate
        }}</label>
        <textarea rows="5" cols="30" pInputTextarea formControlName="notes" [autoResize]="true"> </textarea>
      </div>

      <div class="flex justify-content-end gap-2 dialogBtnGroup">
        <app-button [buttonText]="translate.instant('common.cancel')" (click)="closeDialog()"></app-button>
        <app-button
          [buttonText]="translate.instant('common.save')"
          [disabled]="!form.valid || requestStarted()"
          (click)="save()"
        ></app-button>
      </div>
    </div>
  }
}
